import { dcpcApi } from './dcpcApi';
import { getToasterError } from '../utils';
import { CHANNEL_PARAMS_MUTATION_TAG } from './channelParamApi';

export const CHANNELS_TAG = 'CHANNELS';
const CHANNEL_TYPES_TAG = 'ChannelTypes';
const CHANNEL_INSTANCE_TAG = 'ChannelInstance';

dcpcApi.enhanceEndpoints({ addTagTypes: [CHANNELS_TAG, CHANNEL_INSTANCE_TAG, CHANNEL_TYPES_TAG] });

const channelsApi = dcpcApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getChannels: builder.query({
      query: () => 'channels',
      providesTags: [CHANNELS_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'канала', 'channels');
        }
      },
    }),
    getChannelById: builder.query({
      query: (id) => `channels/${id}`,
      providesTags: [CHANNELS_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'канала', 'channels');
        }
      },
    }),
    updateChannel: builder.mutation({
      query: (args) => ({
        url: `channels/${args?.id || ''}`,
        method: args?.id ? 'PUT' : 'POST',
        body: args,
      }),
      invalidatesTags: [CHANNELS_TAG],
    }),
    deleteChannel: builder.mutation({
      query: (id) => ({
        url: `channels/${id || ''}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CHANNELS_TAG],
    }),
    getChannelParams: builder.query({
      query: (id) => `channels/${id}/params`,
    }),
    getChannelParamByChannelIdAndChannelTypeId: builder.query({
      query: ({ id, paramId }) => `channels/${id}/params/${paramId}`,
      providesTags: (result) => {
        if (result) {
          return [{ type: CHANNEL_PARAMS_MUTATION_TAG, id: result.id || result.channelTypeParamId }];
        }
        return [];
      },
    }),
    getChannelInstance: builder.query({
      query: () => 'a/channelInstance',
      providesTags: [CHANNEL_INSTANCE_TAG],
    }),
    changeChannelInstance: builder.mutation({
      query: (args) => `a/channelInstance/${args.id}/${args.method}`,
      invalidatesTags: [CHANNEL_INSTANCE_TAG],
    }),
  }),
});

export const {
  useGetChannelByIdQuery,
  useGetChannelsQuery,
  useGetChannelParamsQuery,

  useGetChannelInstanceQuery,
  useChangeChannelInstanceMutation,

  useUpdateChannelMutation,
  useDeleteChannelMutation,

  useGetChannelParamByChannelIdAndChannelTypeIdQuery,
} = channelsApi;
